import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import classes from "./base-editor.module.scss";
import { selectCanvas } from "../../reducers/pdf-viewer/selectors";
import classNames from "classnames";
import DrawingItem from "./atomics/drawing-item";
import { Layer, Stage } from "react-konva";
import NewItemsBoard from "./atomics/new-items-board";
import {setActiveDetectedField, setActiveObjectId} from "../../reducers/editor/actions";
import {selectActiveDetectedFieldId, selectActiveObjectId} from "../../reducers/editor/selectors";

const BaseEditor = ({
  width,
  height,
  canMouseDown = true,
  handleMouseDownFunc = () => {},
  handleMouseUpFunc = () => {},
  position,
  cursorClass,
  pageRef,
  convertXToPdfUnits,
  convertYToPdfUnits,
}) => {
  const dispatch = useDispatch();

  const activeObjectId = useSelector(selectActiveObjectId);
  const activeDetectedFieldId = useSelector(selectActiveDetectedFieldId);

  const canvas = useSelector(selectCanvas);

  const [isMouseDown, setIsMouseDown] = useState(false);
  const [mouseDownPositionX, setMouseDownPositionX] = useState(undefined);
  const [mouseDownPositionY, setMouseDownPositionY] = useState(undefined);
  const [isOnCanvasItem, setIsOnCanvasItem] = useState(false);
  const [isOnGroupItem, setIsOnGroupItem] = useState(false);
  const [isDragOrResize, setIsDragOrResize] = useState(false);

  const handleMouseDown = (e) => {
    if (!canMouseDown || isOnCanvasItem) return;

    setIsMouseDown(true);
    setMouseDownPositionX(position.x);
    setMouseDownPositionY(position.y);
    handleMouseDownFunc(position.x, position.y, canvas);
  };

  const resetMouseData = () => {
    setIsMouseDown(false);
    setMouseDownPositionX(undefined);
    setMouseDownPositionY(undefined);
  };

  const handleMouseUp = () => {
    if (isOnCanvasItem) {
      return;
    }

    handleMouseUpFunc(
      mouseDownPositionX,
      mouseDownPositionY,
      position.x,
      position.y,
      canvas
    );
    resetMouseData();
  };

  const cursorIsOnCanvasItem = (e) => {
    setIsOnCanvasItem(true);
    e.evt.preventDefault();
    e.evt.stopPropagation();
  };

  const removeIsOnCanvasItem = (e) => {
    setIsOnCanvasItem(false);
  };

  const handleOnClick = (e) => {
    if (isOnGroupItem) {
      setIsOnCanvasItem(true);
    } else {
      if (!isDragOrResize) {
        dispatch(setActiveObjectId(null));
        dispatch(setActiveDetectedField(null));
      }
    }
    setIsOnGroupItem(false);
    setIsDragOrResize(false)
  }

  const handleOnGroupItemClick = (isDragOrResize) => {
    setIsOnGroupItem(true);
    setIsDragOrResize(isDragOrResize);
  }


  useEffect(() => {
    if (activeDetectedFieldId === null && activeObjectId === null) {
      setIsOnCanvasItem(false);
    }
  }, [activeDetectedFieldId, activeObjectId]);

  return (
    <>
      <div
        className={classes.EditorWrap}
        style={{ width: width + "px", height: height + "px", maxWidth: "100%" }}
        tabIndex="0"
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={resetMouseData}
        onClick={handleOnClick}
      >
        <DrawingItem
          position={position}
          pageRef={pageRef}
          isMouseDown={isMouseDown}
          mouseDownPositionX={mouseDownPositionX}
          mouseDownPositionY={mouseDownPositionY}
          convertXToPdfUnits={convertXToPdfUnits}
          convertYToPdfUnits={convertYToPdfUnits}
        />
        <Stage
          className={classNames(classes.Editor, cursorClass)}
          width={canvas.canvasWidth}
          height={canvas.canvasHeight}
        >
          <Layer>
            <NewItemsBoard
              handleOnGroupItemClick={handleOnGroupItemClick}
              cursorIsOnCanvasItem={cursorIsOnCanvasItem}
              removeIsOnCanvasItem={removeIsOnCanvasItem}
            />
          </Layer>
        </Stage>
      </div>
    </>
  );
};

export default BaseEditor;
